import React from "react";
import {
    TextInput,
    ArrayInput,
    SimpleFormIterator,
} from 'react-admin';
import required from "../helper/Required";
import CustomAddButton from "./CustomAddButton";
import CustomRemoveButton from "./CustomRemoveButton";

class WorkHoursInputWeekEnd extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    render() {
        return (
            <ArrayInput
                {...this.props}
            >
                <SimpleFormIterator addButton={<CustomAddButton />} removeButton={<CustomRemoveButton />}>
                    <TextInput label="Початок" source="start" />
                    <TextInput label="Закінчення" source="end" />
                </SimpleFormIterator>
            </ArrayInput>
        );
    }
}

export default WorkHoursInputWeekEnd;
